module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAMAAACeyVWkAAAAQlBMVEUAAAAre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8vt8POkxOQzgM3l6/HN3exzptpKjtGtyeYIx8TdAAAADXRSTlMA8Y0kTMy3rjMw5chRvQS2QgAAAIlJREFUGNN1kVsOhDAIRYFara1QX7P/rY5aGKNhztfNSXMbABojlcy50Ag3YWBjCCY75BvsVPKTSwd8WTxLen7TAyTL82e2mIAsVqkWCYqmTUQ2zRFyC/ty2GXX/0BLVzlZtRpQSxtV30ZWDse/XnIsQXJscmfz9+Dv7GJ67Hf6fwu7W0TGaHf7ArUxEUvM09A6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_up2.png
// module id = jIhh
// module chunks = 9